import { PageHeader } from '@components/common/PageHeader';
import { SectionCard } from '@components/common/SectionCard';
import { FeaturesCatalogPanel } from '@components/accounts/FeaturesCatalogPanel';

export function FeaturesPage() {
  return (
    <div className="space-y-8">
      <PageHeader
        title="Features Matrix"
        subtitle="Manage the system's global feature catalog, assign features to subscription tiers, and configure auto-discovered flags."
      />

      <SectionCard
        title="Feature Entitlement Matrix"
        subtitle="Define, organize, and assign feature capabilities to different pricing plans."
      >
        <FeaturesCatalogPanel />
      </SectionCard>
    </div>
  );
}
